import { WorkflowEvent, WorkflowEventTypes } from '@amzn/awscat-pattern-library-service-model';
import { DateTime } from 'luxon';
import React from 'react';
import PortalServiceClient from '../../../api/PortalServiceClient';
import '../../../resources/styles/scss/components/pages/reviewer/ReviewFeedbackItem.css';
import LoadingIndicator from '../../common/LoadingIndicator';
import { Box } from '@amzn/awsui-components-core';

interface ReviewFeedbackItemProps {
  workflowEvent: WorkflowEvent;
}

interface ReviewFeedbackItemState {
  isLoadingUserProfile: boolean;
  userName?: string;
}

class ReviewFeedbackItem extends React.Component<ReviewFeedbackItemProps, ReviewFeedbackItemState> {
  private readonly portalService: PortalServiceClient;
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.portalService = PortalServiceClient.create();
    this.state = {
      isLoadingUserProfile: true,
    };
  }

  public async componentDidMount() {
    this.setState({ isLoadingUserProfile: true });
    const { workflowEvent } = this.props;
    const userProfiles = await this.portalService.getUserProfiles([workflowEvent.createdBy]);

    this.setState({
      isLoadingUserProfile: false,
      userName:
        userProfiles.length > 0 && userProfiles[0] ? userProfiles[0].name : workflowEvent.createdBy,
    });
  }

  public render() {
    const { workflowEvent } = this.props;
    const { isLoadingUserProfile, userName } = this.state;
    if (isLoadingUserProfile) {
      return (
        <div className={'review-feedback-item'}>
          <LoadingIndicator />
        </div>
      );
    }

    const comment = workflowEvent.comment ? (
      <Box variant="div" padding={{ bottom: 's' }}>
        {workflowEvent.comment}
      </Box>
    ) : null;

    return (
      <div className="review-feedback-item">
        <div>
          <Box variant="strong">{this.getWorkflowEventTypeDisplayString(workflowEvent.type)}</Box>{' '}
          by {userName}
        </div>
        <div>{workflowEvent.createdAt.toLocaleString(DateTime.DATETIME_FULL)}</div>
        {comment}
      </div>
    );
  }

  private getWorkflowEventTypeDisplayString(type: WorkflowEventTypes) {
    switch (type) {
      case WorkflowEventTypes.APPROVE:
        return 'Approved';
      case WorkflowEventTypes.DISAPPROVE:
        return 'Sent back to author';
      case WorkflowEventTypes.REJECT:
        return 'Publication rejected';
      case WorkflowEventTypes.PUBLISH:
        return 'Published';
      case WorkflowEventTypes.UNPUBLISH:
        return 'Unpublished';
      case WorkflowEventTypes.LOCK:
        return 'Edited';
      case WorkflowEventTypes.SEND_FOR_REVIEW:
        return 'Sent for review';
      case WorkflowEventTypes.CHANGE_OWNER:
        return 'Change owner';
      case WorkflowEventTypes.FINALIZE:
        return 'Finalized';
      case WorkflowEventTypes.DISTRIBUTE:
        return 'Distributed to APG';
      case WorkflowEventTypes.REVOKE:
        return 'Revoked from APG';
      case WorkflowEventTypes.EDIT_CONTENT_TYPE:
        return 'Content type changed';
      case WorkflowEventTypes.RETRACT_REVIEW:
        return 'Review retracted';
      case WorkflowEventTypes.AUTO_REMOVE_REVIEWER:
        return 'Peer reviewer auto-removed';
      case WorkflowEventTypes.PREAUTHORING_APPROVE:
        return 'Publisher approved';
      case WorkflowEventTypes.PREAUTHORING_REJECT:
        return 'Publisher sent back to author';
      case WorkflowEventTypes.PREAUTHORING_NEED_MORE_INFO:
        return 'Publisher requested user to provide more information';
      case WorkflowEventTypes.NO_UPDATES_NEEDED:
        return 'Bar raiser reviewed - no updates needed';
      case WorkflowEventTypes.UPDATES_NEEDED:
        return 'Bar raiser reviewed - author updates needed';
      case WorkflowEventTypes.UNPUBLISH_RECOMMENDED:
        return 'Bar raiser recommended unpublishing';
      case WorkflowEventTypes.CONFIRM_UNPUBLISH:
        return 'Bar raiser confirmed unpublishing';
      case WorkflowEventTypes.PROPOSAL_APPROVE:
        return 'Created draft';
      default:
        return 'Unknown Action';
    }
  }
}

export default ReviewFeedbackItem;
